module.exports = __webpack_public_path__ + "img/icon-market-animal-food.a7de102e.png";